import type { IconProps } from './types';

export const ChevronDownIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M21.8438 6.84375L12 16.6875L2.15625 6.84375" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
